// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewAndCertification_container__ZhGKs"};